export const SET_AUTHED_USER = 'authedUser/SET';
export const UNSET_AUTHED_USER = 'authedUser/UNSET';
